import { toast, Flip } from "react-toastify";

export const notify = (message: string) => {
  toast(message, {
    position: "bottom-center",
    autoClose: 1500,
    closeButton: false,
    hideProgressBar: true,
    style: {
      background: "linear-gradient(90deg, #1692fc 0%, #1562fc 100%)", // tailwind 그라데이션과 동일하게 적용
      color: "white",
      borderRadius: "12px",
      padding: "10px",
      margin: "10px",
      // marginBottom: "64px",
      textAlign: "center",
      maxWidth: "320px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "semibold",
      fontSize: "14px",
      bottom: "64px",
      wordBreak: "keep-all", // break-keep 효과 추가 (한글 줄바꿈 개선)
      minHeight: "56px",
      whiteSpace: "pre-line", // \n을 줄바꿈으로 처리
    },
    transition: Flip, // 애니메이션 효과
  });
};

export const notifyError = (errorMessage: string) => {
  toast.error(errorMessage, {
    position: "bottom-center",
    autoClose: 1500,
    closeButton: false,
    hideProgressBar: true,
    style: {
      backgroundColor: "#ff4d4d", // 에러 메시지 배경색
      color: "white",
      borderRadius: "12px",
      padding: "10px",
      margin: "10px",
      textAlign: "center",
      maxWidth: "320px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "semibold",
      fontSize: "14px",
      bottom: "64px",
      wordBreak: "keep-all", // break-keep 효과 추가 (한글 줄바꿈 개선)
      minHeight: "56px",
      whiteSpace: "pre-line", // \n을 줄바꿈으로 처리
    },
    transition: Flip, // 애니메이션 효과
  });
};
